module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av581-54ec6ce1313ec69dac15f38beac01116.jpg";